import { render, staticRenderFns } from "./miscell.vue?vue&type=template&id=bcc5c830&"
import script from "./miscell.vue?vue&type=script&lang=js&"
export * from "./miscell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports